// test2070
(2070 && 0);
